import Hw3Item from '../Hw3Item';
import React from 'react';

const Hw3List = ({ data = [] }) => {
    return (
        data.map((film) => (
            <li  key={Date.now()+Math.random().toString(16).substr(2, 8)} className="hw3Grid-item">
                <Hw3Item key={film.id} info={film} />
            </li>
            ))
    )
}

export default Hw3List;